var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('img',{staticClass:"svg-icon",class:_vm.className,attrs:{"src":_vm.src}}):(_vm.icon)?_c('i',{staticClass:"icon group-icon",class:_vm.icon}):_c('i',{staticClass:"icon icon-extension"})
}
var staticRenderFns = []

export { render, staticRenderFns }